export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

// export const CART_START = "CART_START";
// export const CART_SUCCESS = "CART_SUCCESS";
// export const CART_FAIL = "CART_FAIL";


export const GET_USER_ACTION = "GET_USER_ACTION";
// export const GET_USER_NAME = "GET_USER_NAME";
export const GET_PERMISSION = "GET_PERMISSION";
export const GET_LIST_SERVICE = "GET_LIST_SERVICE";
